import { normalizeDrippingDataFromMask } from 'helpers/Dripping';
import { htmlStringIsEmpty } from 'helpers/String';
import cloneDeep from 'lodash/cloneDeep';
import { toJS } from 'mobx';

import AdvertisementDataService from './AdvertisementDataService';
import Store from './AdvertisementEditorStore';

class AdvertisementEditorPreventLeaveService {
  initSnapshot(snapshot) {
    const customSnapshot = this.customizeProps(snapshot);

    Store.snapshot = customSnapshot;
  }

  updateSnapshot() {
    const currentSnapshot = this.getCurrentSnapshot();

    this.initSnapshot(currentSnapshot);
  }

  getCurrentSnapshot() {
    const { media } = Store;
    const advertisementData = {};

    const {
      imageId,
      mediaId,
      affiliateHotlink,
      affiliationKey,
      marketplaceProductId,
      mediaVideoProvider,
      mediaVideoUrl,
      offers
    } = AdvertisementDataService.getData(Store);

    const customizedOffers = this.getCustomOffers(offers);

    Object.assign(advertisementData, {
      affiliateHotlink,
      affiliationKey,
      marketplaceProductId,
      mediaVideoProvider,
      mediaVideoUrl,
      offers: toJS(customizedOffers)
    });

    const current = cloneDeep({
      advertisementData,
      image: imageId ? this.getCustomMedia(media) : void 0,
      media: mediaId ? this.getCustomMedia(media) : void 0,
      page: this.getPage()
    });

    return current;
  }

  getPage() {
    const { content, pageId, name, dripping, published, pageLanguage } = Store;
    const {
      durationDays,
      hasDuration,
      liberationDate,
      liberationDays,
      liberationType
    } = dripping;

    const cloneDeepPage = cloneDeep({
      content,
      durationDays,
      hasDuration,
      id: pageId,
      liberationDate,
      liberationDays,
      liberationType,
      name,
      published,
      pageLanguage: pageLanguage && pageLanguage.language ? pageLanguage : null
    });

    const page = normalizeDrippingDataFromMask(cloneDeepPage);

    page.content = this.getCustomPageContent(page);

    return page;
  }

  getCustomPageContent({ content }) {
    return htmlStringIsEmpty(content) ? '' : content;
  }

  getCustomOffers(offers) {
    if (offers) {
      return offers.map(({ offerKey }) => {
        return { offerKey };
      });
    }

    return [];
  }

  getCustomMedia(media) {
    if (media) {
      return {
        id: AdvertisementDataService.formatMediaId(media),
        name: media.name,
        size: media.size,
        contentType: media.contentType,
        fileOrder: media.fileOrder,
        thumborSignedUrl: media.thumborSignedUrl,
        creationDate: media.creationDate
      };
    }

    return void 0;
  }

  customizeProps(snapshot) {
    const snapshotToReturn = { ...snapshot };

    this.removeDuplicateProps(snapshotToReturn);

    snapshotToReturn.advertisementData.offers = this.getCustomOffers(
      snapshotToReturn.advertisementData.offers
    );

    const { media, image } = snapshotToReturn;

    if (media) {
      snapshotToReturn.media = this.getCustomMedia(media);
    } else if (image) {
      snapshotToReturn.image = this.getCustomMedia(image);
    }

    return snapshotToReturn;
  }

  removeDuplicateProps(snapshot) {
    // There is tags property outsite page object already.
    // It is duplicated inside page object.
    if (snapshot.page && snapshot.page.tags) {
      delete snapshot.page.tags;
    }
  }
}

export default new AdvertisementEditorPreventLeaveService();
